import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { EMarkAllAsReadNotificationActionTypes, TMarkAllAsReadNotificationFailed } from './types';

export const markAllAsReadFailed: () => TMarkAllAsReadNotificationFailed =
  actionGenerator<EMarkAllAsReadNotificationActionTypes.Failed>(EMarkAllAsReadNotificationActionTypes.Failed);
